module.exports = __webpack_public_path__ + "img/icon12.5f04fc6b.png";